<template>
  <div class="auth-page">
    <div class="auth-hero">
      <img class="auth-logo" src="~@/assets/image/logo.png" alt="logo">
    </div>

    <div class="auth-tabs compact">
      <button class="auth-tab" type="button" @click="goLogin">登录</button>
      <button class="auth-tab active" type="button">注册</button>
    </div>

    <div class="auth-form">
      <div class="inline-field">
        <span class="inline-label">姓名</span>
        <input v-model.trim="form.name" class="inline-input" type="text" placeholder="请输入姓名">
      </div>
      <div class="inline-field">
        <span class="inline-label">手机号</span>
        <input v-model.trim="form.phone" class="inline-input" type="tel" placeholder="请输入手机号">
      </div>
      <div class="inline-field">
        <span class="inline-label">身份证号</span>
        <input v-model.trim="form.idCard" class="inline-input" type="text" placeholder="请输入身份证号">
      </div>
      <div class="inline-field">
        <span class="inline-label">所在单位</span>
        <input v-model.trim="form.hospital" class="inline-input" type="text" placeholder="请输入所在单位">
      </div>
      <div class="captcha-row">
        <div class="inline-field captcha-field">
          <span class="inline-label">验证码</span>
          <input v-model.trim="form.captchaCode" class="inline-input" type="text" placeholder="请输入验证码">
        </div>
        <button class="captcha-img" type="button" aria-label="刷新验证码" @click="loadCaptcha">
          <img v-if="captchaImage" :src="captchaImage" alt="验证码">
          <van-loading v-else type="spinner" color="#45cbd7" size="18" />
        </button>
      </div>

      <div class="form-separator"></div>

      <div class="inline-field">
        <span class="inline-label">密码</span>
        <input v-model.trim="form.password" class="inline-input" type="password" placeholder="请输入密码">
      </div>
      <div class="inline-field">
        <span class="inline-label">密码</span>
        <input v-model.trim="confirmPassword" class="inline-input" type="password" placeholder="请再次确认输入密码">
      </div>

      <button class="agreement" type="button" @click="agreed = !agreed">
        <van-icon :name="agreed ? 'checked' : 'circle'" />
        <span>我已阅读并同意</span>
        <span class="agreement-link" @click.stop="showAgreement">《注册协议》</span>
      </button>

      <button class="primary-btn" type="button" :disabled="loading" @click="handleRegister">
        {{ loading ? '提交中...' : '提交注册' }}
      </button>
    </div>

    <van-popup v-model="agreementVisible" class="agreement-popup" round closeable>
      <div class="agreement-popup-title">注册协议</div>
      <div v-if="agreementLoading" class="agreement-loading">
        <van-loading type="spinner" color="#45cbd7">加载中...</van-loading>
      </div>
      <div v-else class="agreement-content" v-html="agreementContent"></div>
    </van-popup>
  </div>
</template>

<script>
import { getCaptcha, getRegisterAgreement, userRegister } from '@/api/index.js'

export default {
  data() {
    return {
      loading: false,
      agreed: true,
      agreementVisible: false,
      agreementLoading: false,
      agreementContent: '',
      confirmPassword: '',
      captchaImage: '',
      form: {
        captchaKey: '',
        captchaCode: '',
        name: '',
        phone: '',
        idCard: '',
        hospital: '',
        password: ''
      }
    }
  },
  mounted() {
    this.loadCaptcha()
  },
  methods: {
    goLogin() {
      this.$router.push({
        path: '/login',
        query: this.$route.query.redirect ? { redirect: this.$route.query.redirect } : {}
      })
    },
    loadCaptcha() {
      getCaptcha().then(res => {
        const data = res.data || {}
        this.form.captchaKey = data.captchaKey || data.key || data.uuid || ''
        this.captchaImage = data.captchaBase64 || data.img || data.image || data.captchaImage || data.base64 || ''
        if (this.captchaImage && this.captchaImage.indexOf('data:image') !== 0 && this.captchaImage.indexOf('http') !== 0) {
          this.captchaImage = `data:image/png;base64,${this.captchaImage}`
        }
      })
    },
    showAgreement() {
      this.agreementVisible = true
      if (this.agreementContent) return

      this.agreementLoading = true
      getRegisterAgreement().then(res => {
        this.agreementContent = this.resolveAgreementContent(res.data) || '暂无注册协议内容'
      }).finally(() => {
        this.agreementLoading = false
      })
    },
    resolveAgreementContent(data) {
      if (typeof data === 'string') return data
      if (Array.isArray(data)) {
        return data.length ? this.resolveAgreementContent(data[0]) : ''
      }
      if (!data) return ''
      return data.content ||
        data.agreement ||
        data.value ||
        data.configValue ||
        data.registerAgreement ||
        data.text ||
        data.remark ||
        ''
    },
    handleRegister() {
      if (!this.validateForm()) return
      this.loading = true
      userRegister(this.form).then(() => {
        this.$toast.success('注册成功')
        this.goLogin()
      }).catch(() => {
        this.loadCaptcha()
      }).finally(() => {
        this.loading = false
      })
    },
    validateForm() {
      const rules = [
        ['name', '请输入姓名'],
        ['phone', '请输入手机号'],
        ['idCard', '请输入身份证号'],
        ['hospital', '请输入所在单位'],
        ['captchaCode', '请输入验证码'],
        ['password', '请输入密码']
      ]
      for (let i = 0; i < rules.length; i++) {
        const [key, message] = rules[i]
        if (!this.form[key]) {
          this.$toast(message)
          return false
        }
      }
      if (this.form.password !== this.confirmPassword) {
        this.$toast('两次输入的密码不一致')
        return false
      }
      if (!this.agreed) {
        this.$toast('请先同意注册协议')
        return false
      }
      return true
    }
  }
}
</script>

<style scoped lang="scss">
@import './style.scss';
</style>
